module.exports = __webpack_public_path__ + "static/media/loading_big.b3419887.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/loading_big.gif
// module id = 1820
// module chunks = 0